// El token es base64url(payloadJSON).base64url(sig). Devuelve pass_id (lowercased)
// leído del payload SIN verificar la firma (el backend ya la validó en verify).
export const decodePassId = (token: string): string | null => {
    try {
        const seg = token.split('.')[0];
        if (!seg) {
            return null;
        }
        let b64 = seg.replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4 !== 0) {
            b64 += '=';
        }
        const payload = JSON.parse(atob(b64)) as { pass_id?: string };
        return payload.pass_id ? payload.pass_id.toLowerCase() : null;
    } catch {
        return null;
    }
};
